import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminPreloaderService } from 'services/adminpreloader.service';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { UnauthorisedComponent } from './components/unauthorised/unauthorised.component';
import { LoginGuard } from 'services/login.guard';

const routes: Routes = [
  { path: '', loadChildren: () => import('main/main.module').then(m => m.MainModule) },
  { path: 'u', canActivate: [LoginGuard], loadChildren: () => import('login/login.module').then(m => m.LoginModule) },
  // {
  //   path: 'v',
  //   loadChildren: './vendor-login/vendor-login.module#VendorLoginModule'
  // },

  { path: 'unauthorised', component: UnauthorisedComponent },
  // { path: 'page-not-found', component: NotFoundComponent },
  { path: '**', component: NotFoundComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: AdminPreloaderService })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
